export default __webpack_public_path__ + "static/media/logo.4593f484.png";